<template>
  <transition name="modal" :data-score="scores()">
    <div class="results result-page" v-if="category">
      <div class="container">
        <div class="result-page-header">
          <h2>
            <span class="text-red" v-if="category.boldTitle">{{ category.boldTitle }}</span> {{ category.title }}
          </h2>
          <div v-html="category.intro"></div>
        </div>

        <div class="chat">
          <div class="message message-right" :class="runAnimation ? '' : 'message-nobg'">
            <div class="message-content" @touchstart="runAnimation = true" @click="runAnimation = true">Hva kan Semway hjelpe oss med?</div>
            <div class="message-person" v-if="runAnimation">
              <img :src="avatar.icon" alt="" />
            </div>
          </div>
          <div class="message" style="display: none" ref="message1">
            <div class="message-content">Vi kan hjelpe deg med alt av digitale tjenester og markedsføring. Semway er en totalleverandør som hjelper bedrifter å vokse. Vekst, konvertering og gode etterlatte inntrykk for brukerne er med i alt vi gjør. 📈</div>
            <div class="message-person">
              <img src="@/src/assets/message-person.png" alt="" width="45" />
            </div>
          </div>
          <div class="message" style="display: none" ref="message2">
            <div class="message-content">Vi gir deg gjerne et uforpliktende tilbud på ditt neste prosjekt 🚀 Du kan legge igjen ditt telefonnummer eller e-postadresse, så kontakter jeg deg.</div>
            <div class="message-person">
              <img src="@/src/assets/message-person.png" alt="" width="45" />
            </div>
          </div>

          <div class="form" style="display: none" ref="message3">
            <ContactForm @sent="sendEmail(value)"></ContactForm>
          </div>

          <div class="message" style="display: none" ref="message4">
            <div class="message-content">Takk for oversendt. Vi snakkes snart. Om det skulle være noe i mellomtiden, ikke nøl med å ta kontakt!</div>
            <div class="message-person">
              <img src="@/src/assets/message-person.png" alt="" width="45" />
            </div>
          </div>
          <div class="contact-info" style="display: none" ref="message5">
            <div class="img"><img src="@/src/assets/message-person.png" alt="" /></div>
            <div class="text">
              <p><strong>Monica Sandorf</strong><br />Rådgiver & Partner<br /><a href="#">+47 932 04 137</a><br /><a href="#">monica@semway.no</a></p>
            </div>
          </div>
          <div class="chat-btn" style="display: none" ref="message6">
            <a href="https://semway.no" target="_blank" class="btn btn--red">Gå til semway.no</a>
          </div>
          <div class="message" ref="writing" v-if="runAnimation">
            <div class="message-writing">
              <div class="loading">
                <div class="loading__dot"></div>
                <div class="loading__dot"></div>
                <div class="loading__dot"></div>
              </div>
              <div class="loading-info">Monica i Semway skriver</div>
            </div>
            <div class="message-person">
              <img src="@/src/assets/message-person.png" alt="" width="45" />
            </div>
          </div>
        </div>
      </div>
      <!--        <div class="col-sm-12 col-md-6">
          <div class="social-items">
            <p>Del testen med andre</p>
            <ShareNetwork class="btn-link facebook-icon" network="facebook" url="https://ingenord.no/" :title="`${category.facebook}Er du? Ta testen her: https://ingenord.no`" :quote="`${category.facebook}Er du? Ta testen her: https://ingenord.no`"> Facebook </ShareNetwork>
            <a class="btn-link linkedin-icon" href="https://www.linkedin.com/shareArticle/?url=https://ingenord.no" target="_blank"> Linkedin </a>
          </div>
          <div class="btns">
            <p><a class="btn label arrow" href="https://www.cowi.no/ingenord" target="_blank">Møt noen av våre ingenørder</a></p>
            <p><a class="btn-link" href="https://ingenord.no/">Ta testen på nytt</a></p>
          </div>
        </div>
        -->
    </div>
  </transition>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import axios from 'axios'
import results from '../appdata/results.js'
import quiz from '../appdata/quiz.js'

import ContactForm from './common/ContactForm'

export default {
  components: {
    ContactForm: ContactForm
  },
  data() {
    return {
      quiz: quiz,
      total: 0,
      categoryId: null,
      share: false,
      runAnimation: false,
      sentEmail: false
    }
  },
  watch: {
    // whenever question changes, this function will run
    runAnimation: function (newValue, oldValue) {
      if (newValue && newValue != oldValue) {
        setTimeout(() => {
          jQuery(this.$refs.message1).fadeIn()
        }, 2000)
        setTimeout(() => {
          jQuery(this.$refs.message2).fadeIn()
          jQuery(this.$refs.writing).fadeOut()
        }, 4000)
        setTimeout(() => {
          jQuery(this.$refs.message3).fadeIn()
        }, 4300)
      }
    },
    sentEmail: function (newValue, oldValue) {
      if (newValue && newValue != oldValue) {
        //jQuery(this.$refs.message3).hide()
        jQuery(this.$refs.writing).fadeIn()
        setTimeout(() => {
          jQuery(this.$refs.message4).fadeIn()
          jQuery(this.$refs.writing).fadeOut()
        }, 2000)
        setTimeout(() => {
          jQuery(this.$refs.message5).fadeIn()
        }, 2300)
        setTimeout(() => {
          jQuery(this.$refs.message6).fadeIn()
        }, 2600)
      }
    }
  },
  computed: {
    ...mapFields(['answers', 'avatar']),
    category() {
      let categoryId = this.getCategoryId()
      return results[categoryId]
    }
  },
  methods: {
    getCategoryId() {
      this.scores()
      let _self = this
      results.forEach(function (result, index) {
        if (_self.total >= result.points) {
          _self.categoryId = index
        }
      })
      return _self.categoryId
    },
    scores() {
      let answerPoints = 0

      if (Array.isArray(this.answers)) {
        this.answers.forEach(function (item) {
          answerPoints += Number.parseInt(item.points)
        })
      }

      this.total = answerPoints

      return this.total
    },
    sendEmail() {
      this.sentEmail = true
    }
  },
  mounted() {
    // jQuery('body').addClass('result-step')
    // console.log('ga fires')
    // this.$ga.event('ingenord', 'quiz', 'fullført')
  }
}
</script>

<style lang="scss">
.social-items {
  position: relative;
  border: 1px solid #fff;
  padding: 0.75rem 1rem;
  display: inline-block;
  min-width: 305px;

  @media screen and (max-width: 991px) {
    min-width: 267px;

    max-width: 100%;
  }
  .btn-link {
    display: block;
    cursor: pointer;
  }
  p,
  .btn-link {
    font-size: 85%;
    font-weight: bold;
    margin: 0;
    padding: 0.25rem 0;
  }
}
.btns {
  p {
    margin-bottom: 0;
  }
  .btn.label,
  .btn-link {
    font-size: 85%;
  }
  @media screen and (max-width: 991px) {
    .btn.label.arrow {
      padding-left: 3.5rem;
    }
  }
}
.presult {
  .question {
    padding: 0;
    overflow: visible;
  }
  .question-timeline-text {
    display: none;
  }
}
.message-nobg {
  .message-content {
    &:after {
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Result.vue